import { useEffect } from "react";

const ExternalRedirectPage = ({ url, label = "Continue" }) => {
  useEffect(() => {
    window.location.replace(url);
  }, [url]);

  return (
    <div className="min-h-screen pt-20 bg-white">
      <section className="py-24">
        <div className="container-main text-center max-w-2xl">
          <p className="caption mb-4">Redirecting</p>
          <h1 className="heading-2 mb-6">Taking you to {label}.</h1>
          <p className="body-text mb-8">
            If you are not redirected automatically, use the button below.
          </p>
          <a
            href={url}
            className="btn-primary inline-flex items-center justify-center"
          >
            {label}
          </a>
        </div>
      </section>
    </div>
  );
};

export default ExternalRedirectPage;
